import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Partner } from '@chancenwerk/shared/master-data-management/partner/entities/Partner.js';
import { MarktAkquiseContactRecord } from './MarktAkquiseContactRecord.js';
import type { MarktAkquiseStatus } from './MarktAkquiseStatus.js';

/**
 * @entity MarktAkquise
 */
@Entity()
export class MarktAkquise extends MongoEntity {
  public static override _class = 'MarktAkquise';
  public static override _collectionName = 'markt-akquise';

  @Field(() => String)
  partnerID: Maybe<string>;

  @DataLoadedField(() => Partner, ({ partnerID }) => partnerID)
  partner: Maybe<Partner>;

  @Field(() => String)
  status: Maybe<MarktAkquiseStatus>;

  @Field(() => [MarktAkquiseContactRecord])
  contacts: Maybe<MarktAkquiseContactRecord[]>;

  getLatestStatus() {
    return this.contacts?.at(-1)?.status;
  }
}
